/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface PlaylistControllerGetCountByClientId$Params {
  clientWorkspaceId: string;
}

export function playlistControllerGetCountByClientId(http: HttpClient, rootUrl: string, params: PlaylistControllerGetCountByClientId$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
  const rb = new RequestBuilder(rootUrl, playlistControllerGetCountByClientId.PATH, 'get');
  if (params) {
    rb.path('clientWorkspaceId', params.clientWorkspaceId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
    })
  );
}

playlistControllerGetCountByClientId.PATH = '/api/playlist/count/{clientWorkspaceId}';
